import { withChildren } from '@builder.io/react';
import {
  LIGHT_BACKGROUND_COLORS,
  SEMANTIC_COLORS_LIST,
} from '../../../constants';
import { createBuilderModule } from '../../../builder';
import { builderElement } from '../../../builder/element-factories';
import { BlockGrid } from './BlockGrid';

export default createBuilderModule(withChildren(BlockGrid), {
  name: 'BlockGrid',
  image: 'https://cdn.zappy.app/71a7c8c0547ac245aebdc925fa5eb32f.png',
  inputs: [
    {
      name: 'maxColumns',
      type: 'number',
    },
    {
      name: 'sectionHeading',
      type: 'string',
    },
    {
      name: 'sectionHeadingSize',
      type: 'string',
      enum: ['small', 'medium', 'large'],
    },
    {
      name: 'sectionSubheading',
      type: 'string',
    },
    { name: 'ctaText', type: 'string' },
    { name: 'ctaHref', type: 'string' },
    {
      name: 'backgroundColor',
      type: 'string',
      enum: LIGHT_BACKGROUND_COLORS,
    },
    {
      name: 'ctaColor',
      type: 'string',
      enum: SEMANTIC_COLORS_LIST,
    },
  ],
  defaultChildren: Array(3).fill(
    builderElement('BlockGridItem', {
      heading: 'Example heading',
      description: '<p>Example content...</p>',
    }),
  ),
});
